import api from '@/services/api'

export default {
  getAll() {
    return api.get('/companies')
  },
}